import {
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import RepeatIcon from "@mui/icons-material/Repeat";
import EventIcon from "@mui/icons-material/Event";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import { Edit, Flag } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";
import { formatRecurrenceRule } from "../../utils/formatting";

const renderSchedule = (template) => {
  let text, Icon;
  if (template.repeating && template.recurrence) {
    text = formatRecurrenceRule(template.recurrence);
    Icon = RepeatIcon;
  } else if (template.target_date) {
    const date = new Date(template.target_date);
    text = date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    Icon = CrisisAlertIcon;
  } else if (template.event) {
    text = `Event: ${template.event.title}`;
    Icon = EventIcon;
  }
  return (
    <Box display="flex" alignItems="center" mt={1}>
      <Icon fontSize="small" sx={{ mr: 0.5 }} />
      <Typography variant="body2" color="textSecondary">
        {text}
      </Typography>
    </Box>
  );
};

export default function ToDoTemplateListItem({
  template,
  onEdit,
  onDelete,
  showActions,
}) {
  return (
    <ListItem
      alignItems="flex-start"
      secondaryAction={
        showActions && (
          <Box sx={{ display: "flex", gap: 1 }}>
            <IconButton edge="end" size="small" onClick={onEdit}>
              <Edit fontSize="small" />
            </IconButton>
            <IconButton edge="end" size="small" onClick={onDelete}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        )
      }
    >
      <ListItemIcon>
        {template.repeating ? (
          <RepeatIcon color="action" />
        ) : (
          <EventIcon color="action" />
        )}
      </ListItemIcon>
      <ListItemText
        disableTypography
        primary={
          <Typography variant="h6" component="span">
            {template.title}
          </Typography>
        }
        secondary={
          <>
            {renderSchedule(template)}
            {template.deadline && (
              <Box display="flex" alignItems="center" mt={0.5}>
                <Flag fontSize="small" sx={{ mr: 0.5 }} />
                <Typography variant="body2" color="textSecondary">
                  {dayjs(template.deadline).toDate().toLocaleDateString()}
                </Typography>
              </Box>
            )}
          </>
        }
      />
    </ListItem>
  );
}
